var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-/-delete",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.224,15.504 L14.224,3.824 L16,3.824 L16,2.48 L12.192,2.48 L12.192,1.296 L3.808,1.296 L3.808,2.48 L0,2.48 L0,3.824 L1.776,3.824 L1.776,15.504 L14.224,15.504 Z M12.864,14.16 L3.136,14.16 L3.136,3.824 L12.864,3.824 L12.864,14.16 Z M6.416,12.368 L6.416,6.224 L5.232,6.224 L5.232,12.368 L6.416,12.368 Z M8.56,12.368 L8.56,6.224 L7.376,6.224 L7.376,12.368 L8.56,12.368 Z M10.72,12.368 L10.72,6.224 L9.52,6.224 L9.52,12.368 L10.72,12.368 Z",
    id: "\\uE831"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.0f52cf8970e479902e196d0fe7181fd5.svg";
export { ForwardRef as ReactComponent };